import { dayjs } from '.'

type DateFormat = 'DD MMM YYYY' | 'YYYYMMDD'

export type Month = {
  number: number
  name: string
}

export function formatDate(date: Date | string | null | undefined, format: DateFormat) {
  return date != null ? dayjs(date).format(format) : 'Invalid Date'
}

export function toISODate(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD')
}

/** Format ISO string date keeping AWST */
export function formatRaceDateString(
  dateStringOrUndefined: string | undefined,
  format: 'MM/DD/YYYY' | 'YYYY-MM-DD' = 'YYYY-MM-DD'
) {
  // tmp. work around for native bug MOBI-3742 where the date in the querystring can
  // be stripped out
  const dateString = dateStringOrUndefined ?? dayjs().format('YYYY-MM-DD')
  const dateUtcAwst = dayjs.utc(dateString.toLowerCase().split('t')[0]).utcOffset('+08:00')
  if (dateUtcAwst.isValid()) {
    return dateUtcAwst.format(format)
  }
  return dayjs().format(format)
}

/** Convert AWST ISO date and time string to Date object */
export function convertRaceDateTimeStringToDate(dateString: string) {
  const dateUtcAwst = dayjs.utc(dateString).utcOffset('+08:00')
  if (dateUtcAwst.isValid()) {
    return dateUtcAwst.toDate()
  }
  return new Date(dateString)
}

export const months: Month[] = [
  { number: 1, name: 'January' },
  { number: 2, name: 'February' },
  { number: 3, name: 'March' },
  { number: 4, name: 'April' },
  { number: 5, name: 'May' },
  { number: 6, name: 'June' },
  { number: 7, name: 'July' },
  { number: 8, name: 'August' },
  { number: 9, name: 'September' },
  { number: 10, name: 'October' },
  { number: 11, name: 'November' },
  { number: 12, name: 'December' },
]
